import {ID, Resource} from 'simpli-web-sdk'
import DeliveryPeriodResponseSchema from '@/schema/DeliveryPeriodResponse.schema'

export default class DeliveryPeriodResponse extends Resource {
  readonly $name: string = 'DeliveryPeriodResponse'
  readonly $endpoint: string = '/user/indicador/entrega-por-periodo'

  get $id() {
    return this.id
  }
  set $id(val: ID) {
    this.id = val
  }
  get $schema() {
    return DeliveryPeriodResponseSchema(this)
  }

  id: ID = 0
  mes: string = ''
  qtdTotal: number | null = null
  qtdSemOcorrencia: number | null = null
  qtdComOcorrencia: number | null = null
  qtdDevolvidas: number | null = null
}
